/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PutOrganizationPaymentMethodRequest
 */
export interface PutOrganizationPaymentMethodRequest {
    /**
     * 
     * @type {string}
     * @memberof PutOrganizationPaymentMethodRequest
     */
    'paymentMethod': PutOrganizationPaymentMethodRequestPaymentMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof PutOrganizationPaymentMethodRequest
     */
    'externalAccountTransferAgency': PutOrganizationPaymentMethodRequestExternalAccountTransferAgencyEnum;
    /**
     * 
     * @type {string}
     * @memberof PutOrganizationPaymentMethodRequest
     */
    'paymentScheme': PutOrganizationPaymentMethodRequestPaymentSchemeEnum;
}

export const PutOrganizationPaymentMethodRequestPaymentMethodEnum = {
    accountTransfer: 'ACCOUNT_TRANSFER',
    bankTransfer: 'BANK_TRANSFER'
} as const;

export type PutOrganizationPaymentMethodRequestPaymentMethodEnum = typeof PutOrganizationPaymentMethodRequestPaymentMethodEnum[keyof typeof PutOrganizationPaymentMethodRequestPaymentMethodEnum];
export const PutOrganizationPaymentMethodRequestExternalAccountTransferAgencyEnum = {
    moneyForwardKessai: 'MONEY_FORWARD_KESSAI',
    ufj: 'UFJ'
} as const;

export type PutOrganizationPaymentMethodRequestExternalAccountTransferAgencyEnum = typeof PutOrganizationPaymentMethodRequestExternalAccountTransferAgencyEnum[keyof typeof PutOrganizationPaymentMethodRequestExternalAccountTransferAgencyEnum];
export const PutOrganizationPaymentMethodRequestPaymentSchemeEnum = {
    fifteenthDayPayment: 'FIFTEENTH_DAY_PAYMENT',
    twoMonthsLaterFifteenthDayPayment: 'TWO_MONTHS_LATER_FIFTEENTH_DAY_PAYMENT',
    endOfTwoMonthsLaterPayment: 'END_OF_TWO_MONTHS_LATER_PAYMENT',
    twentiethDayPayment: 'TWENTIETH_DAY_PAYMENT',
    endOfMonthPayment: 'END_OF_MONTH_PAYMENT',
    twoMonthsLaterSixthDayPayment: 'TWO_MONTHS_LATER_SIXTH_DAY_PAYMENT'
} as const;

export type PutOrganizationPaymentMethodRequestPaymentSchemeEnum = typeof PutOrganizationPaymentMethodRequestPaymentSchemeEnum[keyof typeof PutOrganizationPaymentMethodRequestPaymentSchemeEnum];


